<mat-form-field subscriptSizing="dynamic" class="input-search">
  <input
    type="text"
    matInput
    placeholder="Go to place..."
    [formControl]="searchControl"
    (keyup.enter)="goToSearchedPlace()"
    [matAutocomplete]="auto"
    autocomplete="off"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event.option.value)"
  >
    @for (autoCompleteResult of autoCompleteResults$(); track autoCompleteResult.label) {
      <mat-option [value]="autoCompleteResult.label">
        {{ autoCompleteResult.label }}
      </mat-option>
    }
  </mat-autocomplete>

  <button
    matIconButton
    matSuffix
    (click)="clearSearch()"
    aria-label="Clear search"
    matTooltip="Clear search"
  >
    <mat-icon>clear</mat-icon>
  </button>
</mat-form-field>
